import React, { Component, createRef } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Button from "../../components/Button";
import {
  Modal,
  ModalHeader,
  ModalContent,
  ModalFooter,
} from "../../components/Modal";
import {
  closeModal,
  createEmail,
  emailTemplatesList,
} from "../../actions";
import { history } from "../../history";
import styles from "../../components/Modal.module.css";

const identity = (data) => data;

export class CreateEmailModal extends Component {
  constructor(props) {
    super(props);
    this.create = this.create.bind(this);
    this.nameRef = createRef();
    this.templateIdRef = createRef();
  }

  componentWillMount() {
    const { accountId } = this.props;
    this.props.emailTemplatesList(accountId);
  }

  componentDidMount() {
    if (this.nameRef?.current) {
      this.nameRef.current.focus();
    }
  }

  create(e) {
    if (e) {
      e.preventDefault();
    }

    const { accountId, campaignId } = this.props;

    this.props
      .createEmail(accountId, {
        name: this.nameRef?.current.value,
        templateId: this.templateIdRef?.current.value,
        campaignId,
      })
      .then((data) => {
        const nextId = data.data.id;
        history.push(`/clients/${accountId}/emails/${nextId}`);
      })
      .then(this.props.closeModal);
  }

  renderTemplateOption(template) {
    return (
      <option value={template.id} key={template.id}>
        {template.name}
      </option>
    );
  }

  render() {
    const { emailTemplates } = this.props;

    return (
      <Modal>
        <ModalHeader>Create Email</ModalHeader>
        <ModalContent>
          <form onSubmit={this.create}>
            <div className={styles.flex}>
              <label>Name</label>
              <input ref={this.nameRef} autoFocus />
            </div>
            <div className={styles.flex}>
              <label>Template</label>
              <select ref={this.templateIdRef}>
                {emailTemplates.map(this.renderTemplateOption)}
              </select>
            </div>
          </form>
        </ModalContent>
        <ModalFooter>
          <Button type="link" onClick={this.props.closeModal}>
            Cancel
          </Button>
          <Button onClick={this.create}>Create</Button>
        </ModalFooter>
      </Modal>
    );
  }
}

CreateEmailModal.propTypes = {
  createEmail: PropTypes.func.isRequired,
  emailTemplatesList: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  emailTemplates: PropTypes.array.isRequired,
  accountId: PropTypes.string.isRequired,
};

// Connect state data
function mapStateToProps(state) {
  const { params } = state.modal;
  const accountId = params.accountId;
  const campaignId = params.campaignId;
  const emailTemplatesPagination = state.pagination.emailTemplates || {};
  const emailTemplates = (emailTemplatesPagination.ids || [])
    .map((id) => state.entities.emailTemplate[id])
    .filter(identity);

  return {
    accountId,
    campaignId,
    emailTemplates,
  };
}

// Connect actions
export default connect(mapStateToProps, {
  closeModal,
  createEmail,
  emailTemplatesList,
})(CreateEmailModal);
